var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0893 1.07745C18.4147 1.40289 18.4147 1.93053 18.0893 2.25596L11.7143 8.63096C11.3888 8.9564 10.8612 8.9564 10.5358 8.63096L7.37502 5.47022L3.08928 9.75596C2.76384 10.0814 2.2362 10.0814 1.91076 9.75596C1.58533 9.43053 1.58533 8.90289 1.91076 8.57745L6.78576 3.70245C7.1112 3.37701 7.63884 3.37701 7.96428 3.70245L11.125 6.8632L16.9108 1.07745C17.2362 0.752015 17.7638 0.752015 18.0893 1.07745Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.66671C12.5 1.20647 12.8731 0.833374 13.3333 0.833374H17.5C17.9602 0.833374 18.3333 1.20647 18.3333 1.66671V5.83337C18.3333 6.29361 17.9602 6.66671 17.5 6.66671C17.0398 6.66671 16.6667 6.29361 16.6667 5.83337V2.50004H13.3333C12.8731 2.50004 12.5 2.12694 12.5 1.66671Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10.8334C12.9603 10.8334 13.3334 11.2065 13.3334 11.6667V18.3334C13.3334 18.7936 12.9603 19.1667 12.5 19.1667C12.0398 19.1667 11.6667 18.7936 11.6667 18.3334V11.6667C11.6667 11.2065 12.0398 10.8334 12.5 10.8334Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8.33337C17.9603 8.33337 18.3334 8.67982 18.3334 9.10718V18.3929C18.3334 18.8203 17.9603 19.1667 17.5 19.1667C17.0398 19.1667 16.6667 18.8203 16.6667 18.3929V9.10718C16.6667 8.67982 17.0398 8.33337 17.5 8.33337Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50002 9.16663C7.96026 9.16663 8.33335 9.53972 8.33335 9.99996L8.33335 18.3333C8.33335 18.7935 7.96026 19.1666 7.50002 19.1666C7.03978 19.1666 6.66669 18.7935 6.66669 18.3333L6.66669 9.99996C6.66669 9.53972 7.03978 9.16663 7.50002 9.16663Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50002 13.3334C2.96026 13.3334 3.33335 13.7065 3.33335 14.1667V18.3334C3.33335 18.7936 2.96026 19.1667 2.50002 19.1667C2.03978 19.1667 1.66669 18.7936 1.66669 18.3334V14.1667C1.66669 13.7065 2.03978 13.3334 2.50002 13.3334Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.cebdf26ffb215ee02ec53b4dedc711b1.svg";
export { ForwardRef as ReactComponent };